<script>
  import { t } from '../../i18n/index.js';

  let { onClose, onReconnect, title = '', message = '' } = $props();
</script>

<div class="dialog-overlay">
  <div class="dialog-content">
    <div class="mb-4">
      <svg class="h-16 w-16 mx-auto text-yellow-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3" />
      </svg>
    </div>
    <h3 class="text-xl font-bold mb-3">{title || t('disconnect.title')}</h3>
    <p class="text-gray-400 mb-6 whitespace-pre-line">{message || t('disconnect.message')}</p>
    <button
      onclick={onReconnect}
      class="btn-large w-full py-4 bg-blue-600 hover:bg-blue-500 rounded-xl font-bold text-lg transition-colors"
    >
      {t('disconnect.reconnect')}
    </button>
  </div>
</div>

<style>
  .dialog-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding: 1rem;
  }

  .dialog-content {
    background: #1f2937;
    border-radius: 1rem;
    padding: 2rem;
    max-width: 320px;
    width: 100%;
    text-align: center;
  }

  .btn-large {
    min-height: 60px;
    font-size: 1.125rem;
  }
</style>
